import React from 'react';

import './styles.scss';

import DesktopHeader from './components/DesktopHeader';
import MobileHeader from './components/MobileHeader';

export default ({children}) => {
  return (
    <div className="referral-layout">
      <DesktopHeader />
      <MobileHeader />
      <div className="referral-layout__content">
        {children}
      </div>
    </div>
  )
}
